<cs-header>
  <cs-header-title>{{ LL.intake.nutritionOptions.header() }}</cs-header-title>
</cs-header>

<cs-content>
  @if (!loading && declaredState) {
    <div class="nutrition-options-container">
      <nutrition-options-component [state]="declaredState" (change)="handleChange()"></nutrition-options-component>
    </div>
  }

  @if (loading) {
    <cs-spinner></cs-spinner>
  }
</cs-content>